import React, { useRef, forwardRef } from "react";
import PropTypes from "prop-types";
import { Box, createPolymorphicComponent, ScrollArea } from "@mantine/core";
import { useMergedRef } from "@mantine/hooks";
import {
  CellContext,
  ColumnDefBase,
  ColumnDefTemplate,
  HeaderContext,
  RowData,
  StringOrTemplateHeader,
} from "@tanstack/react-table";

export interface IColumnProps<TData extends RowData, TValue = unknown> {
  //extends ColumnDefBase<TData, TValue>
  fieldName: string;
  header?: string | ColumnDefTemplate<HeaderContext<TData, TValue>>;
  footer?: string | ColumnDefTemplate<HeaderContext<TData, TValue>>;
  resizable?: boolean;
  sortable?: boolean;
  minSize?: number;
  size?: number;
  cellTemplate?: ColumnDefTemplate<CellContext<TData, TValue>>;
  fixed?: boolean | "left" | "right";
  children?: IColumnProps<TData, TValue>[];
}

export const _Column: React.FC<IColumnProps<any>> = (props) => {
  const { children } = props;

  const itemRef = useRef<any>();

  return null;
};

const propTypes = {
  fieldName: PropTypes.string,
  //align: PropTypes.oneOf(["left", "center", "right"]),
  //verticalAlign: PropTypes.oneOf(["top", "middle", "bottom"]),
  size: PropTypes.number,
  minSize: PropTypes.number,
  fixed: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.oneOf(["left", "right"]),
  ]),
  resizable: PropTypes.bool,
  sortable: PropTypes.bool,
  cell: PropTypes.func,
  // flexGrow: PropTypes.number,
  // minWidth: PropTypes.number,
  // colSpan: PropTypes.number,
  // rowSpan: PropTypes.func,
  // treeCol: PropTypes.bool,
  // onResize: PropTypes.func,
  children: PropTypes.node,
};

_Column.displayName = "DataTable.Column";
_Column.defaultProps = {};
//_Column.propTypes = propTypes;

export const Column =
  createPolymorphicComponent<"div", IColumnProps<any>>(_Column);
